<template>
  <div style="padding-top: 16px">
    <Row :gutter="8">
      <Col span="4">
        <div class="card">
          <div style="height: 30px">项目更新率</div>
          <div class="card-b">
            <span class="card-f">{{ overview.projectAttendanceRate }}%</span>
            <div style="width: 100px">
              <Progress
                :percent="Number(overview.projectAttendanceRate)"
                :stroke-width="6"
                hide-info
                stroke-color="#4B7DF5"
              />
            </div>
          </div>
        </div>
      </Col>
      <Col span="4">
        <div class="card">
          <div style="height: 30px">有考勤数据项目的平均上班工人数</div>
          <div class="card-b">
            <span class="card-f">{{ overview.averageWorkerCount }}</span>
            <div style="width: 100px">
            </div>
          </div>
        </div>
      </Col>
      <Col span="4">
        <div class="card">
          <div style="height: 30px">项目停工率</div>
          <div class="card-b">
            <span class="card-f">{{ overview.projectStopRate }}%</span>
            <div style="width: 100px">
              <Progress
                :percent="Number(overview.projectStopRate)"
                :stroke-width="6"
                hide-info
                status="wrong"
              />
            </div>
          </div>
        </div>
      </Col>
      <Col span="4">
        <div class="card">
          <div style="height: 30px">项目经理到岗率</div>
          <div class="card-b">
            <span class="card-f">{{ overview.managerToPostRate }}%</span>
            <div style="width: 100px">
              <Progress
                :percent="Number(overview.managerToPostRate)"
                :stroke-width="6"
                hide-info
                stroke-color="#29BCC0"
              />
            </div>
          </div>
        </div>
      </Col>
      <Col span="4">
        <div class="card">
          <div style="height: 30px">总监理工程师到岗率</div>
          <div class="card-b">
            <span class="card-f">{{ overview.chiefInspectorToPostRate }}%</span>
            <div style="width: 100px">
              <Progress
                :percent="Number(overview.chiefInspectorToPostRate)"
                :stroke-width="6"
                hide-info
                stroke-color="#FFAD40 "
              />
            </div>
          </div>
        </div>
      </Col>
      <Col span="4">
        <div class="card">
          <div style="height: 30px">项目经理和总监理工程师到岗率</div>
          <div class="card-b">
            <span class="card-f">{{
              overview.managerAndChiefInspectorToPostRate
            }}%</span>
            <div style="width: 100px">
              <Progress
                :percent="Number(overview.managerAndChiefInspectorToPostRate)"
                :stroke-width="6"
                hide-info
                stroke-color="#07C160"
              />
            </div>
          </div>
        </div>
      </Col>
    </Row>
    <Row :gutter="8">
      <Col span="4">
        <div class="card">
          <div style="height: 30px">未设置项目经理的项目数</div>
          <div class="card-b">
            <span class="card-f">{{ overview.unSetManagerProjectCount }}</span>
            <div style="width: 100px">
            </div>
          </div>
        </div>
      </Col>
      <Col span="4">
        <div class="card">
          <div style="height: 30px">未设置总监理工程师的项目数</div>
          <div class="card-b">
            <span class="card-f">{{
              overview.unSetChiefInspectorProjectCount
            }}</span>
            <div style="width: 100px">
            </div>
          </div>
        </div>
      </Col>
      <Col span="4">
        <div class="card">
          <div style="height: 30px">已设置但非注册建造师的项目数</div>
          <div class="card-b">
            <span class="card-f">{{
              overview.noSpecialtyManagerProjectCount
            }}</span>
            <div style="width: 100px">
            </div>
          </div>
        </div>
      </Col>

      <Col span="4">
        <div class="card">
          <div style="height: 30px">已设置但非注册监理工程师的项目数</div>
          <div class="card-b">
            <span class="card-f">{{
              overview.noSpecialtyChiefInspectorProjectCount
            }}</span>
            <div style="width: 100px">
              <!-- <Progress
                :percent="90"
                :stroke-width="7"
                hide-info
                stroke-color="#4B7DF5"
              /> -->
            </div>
          </div>
        </div>
      </Col>
      <!--<Col span="3">
        <div class="card">
          <div style="height: 30px">项目超期未审核办件数</div>
          <div class="card-b">
            <span class="card-f">{{ overview.projectNoCheckCount }}</span>
            <div style="width: 100px">
              &lt;!&ndash; <Progress
                :percent="90"
                :stroke-width="7"
                hide-info
                stroke-color="#4B7DF5"
              /> &ndash;&gt;
            </div>
          </div>
        </div>
      </Col>
      <Col span="3">
        <div class="card">
          <div style="height: 30px">供应商超期未联调办件数</div>
          <div class="card-b">
            <span class="card-f">{{
              overview.supplierNoIntergratedTestCount
            }}</span>
            <div style="width: 100px">
              &lt;!&ndash; <Progress
                :percent="90"
                :stroke-width="7"
                hide-info
                stroke-color="#4B7DF5"
              /> &ndash;&gt;
            </div>
          </div>
        </div>
      </Col>
      <Col span="3">
        <div class="card">
          <div style="height: 30px">供应商超期未审核办件数</div>
          <div class="card-b">
            <span class="card-f">{{ overview.supplierNoCheckCount }}</span>
            <div style="width: 100px">
              &lt;!&ndash; <Progress
                :percent="90"
                :stroke-width="7"
                hide-info
                stroke-color="#4B7DF5"
              /> &ndash;&gt;
            </div>
          </div>
        </div>
      </Col>-->
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      overview: {},
      newTime: [],
      newAreaCode: "",
    };
  },
  props: {
    time1: {
      type: Array,
      default: function () {
        return [];
      },
    },
    areaCode1: {
      type: String,
      default: "",
    },
  },
  components: {},
  computed: {},
  watch: {
    time1(curVal, oldVal) {
      if (curVal) {
        this.newTime = curVal;
        this.setDefaultDate();
      }
    },
    areaCode1(curVal, oldVal) {
      if (curVal) {
        this.newAreaCode = curVal;
        this.setDefaultDate();
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    setDefaultDate() {
      let param = {
        startDate: this.newTime[0] ? this.newTime[0] : "",
        endDate: this.newTime[1] ? this.newTime[1] : "",
        areaCode: this.areaCode1,
      };
      this.axios({
        method: "post",
        url: "/gd/trendStatistics/queryTrendStatisticsOverView",
        data: param,
      }).then((response) => {
        if (response.data.success) {
          this.overview = response.data.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.card {
  width: 100%;
  height: 110px;
  background: #ffffff;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-bottom: 15px;
  padding: 0px 20px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .card-b {
    border-top: 1px solid rgba(75, 125, 245, 0.2);
    padding-top: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-f {
      font-size: 24px;
      font-family: Arial;
      font-weight: bold;
      color: #333333;
    }
  }
}
// .text-bar{
//   height: 60px;
//   display: flex;
//   align-items: center;
//   padding: 0 20px
// }
</style>
